import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'

import './ProjectItem.css'
import template from './ProjectItemCall.jinja'

const PARENT_FRAME_SHIFT = 2
const FRAME_SHIFT_X = 46 + PARENT_FRAME_SHIFT
const FRAME_SHIFT_Y = 35 + PARENT_FRAME_SHIFT


var ProjectItem = BaseView.extend({
    template: template,

    events: {
        //'click .ProjectItem-link': 'navigate'
    },

    render() {
        let $html = $(this.template.render({p: this.model}))
        app.els.$content.append($html)
        this.setElement($html)

        this.$el.addClass('isNotActive')

        return this
    },

    initialize (options) {
        _.bindAll(this, 'activateElement')
    },

    navigate(e) {
        e.preventDefault()
        let url = $(e.target).closest('a').attr('href')

        this.activateElement()
            .then(() => {
                app.router.navigate(url, {trigger: 'true'})
            })
    },

    activateElement() {
        let $loader = $(app.loader.loader)
        let $copy = this.$el.clone()

        let elPosition = this.$el.offset()
        let elX = elPosition.left
        let elY = elPosition.top

        let newX = elX
        let newY = elY - app.els.$window.scrollTop()

        $copy.css({top: newY, left: newX, width: this.$el.width()})

        $copy = $copy.appendTo($loader)
        let $img = $copy.find('.ProjectItem-imgContainer')

        $loader.addClass('Loader--projectItem')
        $.Velocity.hook($loader[0], 'display', 'block')

        app.views.nav.deactivate({duration: 500})
        return $.Velocity.animate(app.router.view.el, {opacity: 0}, {duration: 500, easing: 'easeInQuad'})
            .then(() => {
                app.els.$body.addClass('u-NoOverflow')

                $.Velocity.hook($copy[0], 'transformOriginX', $img.outerWidth() / 2 + 'px')
                $.Velocity.hook($copy[0], 'transformOriginY', $img.outerHeight() / 2 + 'px')

                return $.Velocity.animate($copy[0], {
                    translateX: (app.els.$window.width() / 2 - (newX + $img.outerWidth() / 2) + FRAME_SHIFT_X / 2) + 'px',
                    translateY: (app.els.$window.height() / 2 - (newY + $img.outerHeight() / 2) + FRAME_SHIFT_Y / 2 ) + 'px'
                }, {
                    duration: 600,
                    easing: 'easeInOutCubic',
                    complete() {
                        $copy.addClass('isLoading')
                    }
                })
            })
    }
})

export default ProjectItem


// WEBPACK FOOTER //
// ./assets/app/front/components/ProjectItem/ProjectItem.js